<template>
  <b-navbar toggleable="md" type="light" variant="light">
    <b-navbar-toggle target="nav_collapse">
      <div>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </b-navbar-toggle>

    <app-navbar-brand
      :cityName="cityName"
      :cityWebsite="cityWebsite"
      :logoLink="logoLink"
    />

    <b-collapse is-nav id="nav_collapse">
      <app-navbar-menu />

      <!-- Right aligned nav items -->
      <b-navbar-nav class="ml-auto" id="nav_right">
        <app-navbar-user
          :userName="userName"
          @logout="logout"
        />
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
import store from '@/store/';
import { LOGOUT } from '@/store/actions.type';
import appNavbarBrand from './app-navbar-brand.vue';
import appNavbarMenu from './app-navbar-menu.vue';
import appNavbarUser from './app-navbar-user.vue';

export default {
  name: 'app-navbar',
  components: {
    appNavbarBrand,
    appNavbarMenu,
    appNavbarUser,
  },
  computed: {
    logoLink() {
      return store.getters.configuration.logo;
    },
    userName() {
      return store.getters.user.businessName;
    },
    cityName() {
      return store.getters.configuration.cityName;
    },
    cityWebsite() {
      return this.$store.getters.configuration.cityWebsite;
    },
  },
  methods: {
    logout() {
      this.$store.dispatch(LOGOUT);
      this.$router.push('/');
      this.$router.go(0);
    },
  },
};
</script>

<style>
/* VERSION MOBILE */

.navbar {
  min-width: 350px;
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.3);
  padding: 0 !important;
  display: flex;
  align-items: stretch;
  position: sticky;
  top: 0;
  z-index: 2;
}

/* TOGGLER */

.navbar-toggler {
  margin-left: 1.5rem;
  outline: none;
  border: none !important;
}

.navbar-toggler div {
  width: 1.8rem;
  height: 1.8rem;
  position: relative;
  transform: rotate(0deg);
  transition: 0.5s ease-in-out;
  cursor: pointer;
}

.navbar-toggler div span {
  display: block;
  position: absolute;
  height: 0.2rem;
  width: 100%;
  background: var(--theme-color);
  border-radius: 9px;
  opacity: 1;
  left: 0;
  transform: rotate(0deg);
  transition: 0.25s ease-in-out;
}

.navbar-toggler div span:nth-child(1) {
  top: 0.2rem;
}

.navbar-toggler div span:nth-child(2),
.navbar-toggler div span:nth-child(3) {
  top: 0.7rem;
}

.navbar-toggler div span:nth-child(4) {
  top: 1.2rem;
}

.navbar-toggler[aria-expanded="true"] div span:nth-child(1) {
  top: 0.7rem;
  width: 0%;
  left: 50%;
}

.navbar-toggler[aria-expanded="true"] div span:nth-child(2) {
  transform: rotate(45deg);
}

.navbar-toggler[aria-expanded="true"] div span:nth-child(3) {
  transform: rotate(-45deg);
}

.navbar-toggler[aria-expanded="true"] div span:nth-child(4) {
  top: 0.7rem;
  width: 0%;
  left: 50%;
}

/* LIENS DANS TOGGLE MENU */

.navbar .nav-item a {
  padding: 1rem;
  outline: none;
}

.navbar .nav-item a div {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.navbar .nav-item a div .icon {
  margin-right: 1rem;
  color: var(--theme-color);
  font-size: 1.5rem;
}

.navbar .nav-item a div p {
  margin: 0;
}

.navbar .nav-item.router-link-active {
  background-color: var(--theme-color);
}
.navbar .nav-item.router-link-active p,
.navbar .nav-item.router-link-active .icon {
  color: #fff;
}

.navbar-nav .nav-item .dropdown-menu {
  border-color: var(--theme-color);
  border-radius: 0;
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.3);
}

@media (min-width: 960px) {
  .navbar {
    min-width: 350px;
    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.3);
    display: flex;
    align-items: stretch !important;
    position: sticky;
    top: 0;
    z-index: 2;
    height: 5rem;
  }

  .navbar * {
    transition: all 0.25s ease 0.5s, color 0s ease 0s,
      background-color 0.4s ease 0.5s;
  }

  /* LIENS */

  .navbar .navbar-collapse {
    display: flex;
    align-items: stretch;
  }

  .navbar .nav-item {
    text-align: center;
    flex-grow: 1;
    flex-basis: 0;
    display: flex;
    align-items: center;
    justify-content: space-around;
    transition: all 0.25s ease 0s, background-color 0.4s ease 0s;
  }

  .navbar .nav-item a {
    padding-top: 1.5rem !important;
    min-width: 10rem;
  }

  .navbar .nav-item a div {
    display: unset;
    justify-content: unset;
    align-items: unset;
  }

  .navbar .nav-item.router-link-active,
  .navbar .nav-item:hover {
    background-color: var(--theme-color);
  }

  .navbar .nav-item.router-link-active .icon,
  .navbar .nav-item.router-link-active p,
  .navbar .nav-item:hover .icon,
  .navbar .nav-item:hover p {
    color: #fff;
  }

  .navbar-nav .nav-item .icon {
    color: var(--theme-color);
    font-size: 2rem !important;
    margin-right: 0 !important;
    margin-bottom: 0;
  }

  .navbar-nav .nav-item .icon.fa-file-signature {
    transform: translateX(0.2rem);
  }

  .navbar-nav .nav-item p {
    font-size: 0;
    opacity: 0;
    margin: 0;
    transition: all 0.25s ease 0.5s, font-size 0s ease 0.5s,
      opacity 1s ease 0.5s, color 0s ease 0s;
  }

  .navbar-nav .nav-item:hover .dropdown-menu {
    display: block;
  }

  .navbar-nav .nav-item .dropdown-menu {
    right: 0;
    left: auto;
    min-width: 15rem;
    width: 100%;
    border-color: var(--theme-color);
    margin-top: 0;
    border-radius: 0;
  }

  .navbar-nav .nav-item .dropdown-menu .dropdown-item {
    padding-left: 1rem;
    padding-right: 1rem;
    color: rgba(0, 0, 0, 0.5);
    border-radius: 0;
    transition: all 0.3s ease;
  }

  .navbar-nav .nav-item .dropdown-menu .dropdown-item span {
    margin-left: 0.2rem;
    transition: all 0.3s ease;
  }

  .navbar-nav .nav-item .dropdown-menu .dropdown-item:active {
    background-color: inherit;
  }

  .navbar-nav .nav-item .dropdown-menu .dropdown-item:focus {
    outline: none;
  }

  .navbar-nav .nav-item .dropdown-menu .dropdown-item:hover {
    background: rgba(0, 0, 0, 0.1);
  }

  .navbar-nav .nav-item .dropdown-menu .dropdown-item:hover span {
    color: #000;
    margin-left: 0.6rem;
  }

  /* SUR LE HOVER DE LA NAVBAR */

  .navbar * {
    transition: all 0.25s ease 0s, color 0s ease 0s, font-size 0s ease 0s !important;
  }

  .navbar #city_logo {
    height: 6.5rem;
  }

  .navbar #city_name {
    font-size: 1rem;
  }

  .navbar .nav-item .icon {
    margin-bottom: .5rem !important;
  }

  .navbar .nav-item p {
    opacity: 1;
    display: block;
    margin-bottom: 0;
    font-size: 1rem;
  }
}

/* IE10+ CSS styles */
@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  .navbar {
    min-height: 85px;
  }

  .navbar-toggler div span,
  .navbar .nav-item.router-link-active,
  .navbar .nav-item:hover {
    background: lightseagreen;
  }

  .navbar-nav .nav-item .dropdown-menu {
    border-color: lightseagreen;
  }

  .navbar .nav-item a div .icon,
  .navbar .nav-item.router-link-active,
  .navbar-nav .nav-item .dropdown-menu {
    color: lightseagreen;
  }

  .navbar-nav {
    -ms-flex-preferred-size: 1000px;
  }
}
</style>
